<template>
    <tree />
</template>


<script>
import tree from '../../../components/network-affiliate/tree.vue';
export default {
    components: {
        tree
    }
}
</script>